import Slider from 'react-slick'
import { LinkedInIcon } from 'assets/icons/LinkedInIcon'
import { TwitterIcon } from 'assets/icons/TwitterIcon'
import { Section9Images } from 'assets/OurStoryImages/Section9'

const iconStyles =
  'bg-white text-[#001A3D] w-6 h-6 rounded-[4px] cursor-pointer hover:text-white hover:border hover:border-[#001A3D] hover:bg-[#001A3D]'
const imageStyles =
  'w-[334px] h-[206px] sm:w-[668px] sm:h-[412px] lg:w-[864px] lg:h-[532px] 2xl:w-[1268px] 2xl:h-[780px] 3xl:w-[1627px] 3xl:h-[1000px]'
const settings = {
  centerMode: true,
  centerPadding: '0px',
  dots: false,
  infinite: true,
  autoplay: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
}

export const Section9 = () => {
  return (
    <>
      <div className='p-10 flex flex-col items-center'>
        <h1 className='mb-5 text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-[64px] text-[#001A3D] font-bold leading-8 tracking-[0.4px]'>
          Press and media
        </h1>
        <div className='flex flex-row gap-4 pt-10 3xl:pt-15'>
          <a href='https://www.linkedin.com/company/legal-utopia/'>
            <LinkedInIcon className={iconStyles} />
          </a>
          <a href='https://x.com/AiLegalutopia' target='_blank'>
            <TwitterIcon className={iconStyles} />
          </a>
        </div>
      </div>
      <div>
        <Slider {...settings}>
          <img src={Section9Images.Press1} className={imageStyles} />
          <img src={Section9Images.Press2} className={imageStyles} />
          <img src={Section9Images.Press3} className={imageStyles} />
          <img src={Section9Images.Press4} className={imageStyles} />
          <img src={Section9Images.Press5} className={imageStyles} />
          <img src={Section9Images.Press6} className={imageStyles} />
          <img src={Section9Images.Press7} className={imageStyles} />
          <img src={Section9Images.Press8} className={imageStyles} />
          <img src={Section9Images.Press9} className={imageStyles} />
          <img src={Section9Images.Press10} className={imageStyles} />
        </Slider>
      </div>
    </>
  )
}
